// This file contains accessibility fixes related to external apps.

export const initStockist = () => {
  const stockist = document.querySelector(".stockist");
  if (stockist) {
    const map = stockist.querySelector(".stockist-map");
    const observer = new MutationObserver((mutationList, observer) => {
      const icons = map.querySelectorAll(
        ".leaflet-marker-icon:not([role='button'])"
      );
      icons.forEach((icon) => {
        const alt = icon.getAttribute("title");
        icon.setAttribute("role", "button");
        icon.setAttribute("aria-label", alt);
      });
    });
    observer.observe(map, { childList: true, subtree: true });
  }
};

export const initGlobo = () => {
  const globo = document.querySelector(".globo-form-app");
  if (globo) {
    const form = globo.querySelector("form");
    form.addEventListener("submit", (event) => {
      // Run this after Globo does what it does
      setTimeout(() => {
        const errors = form.querySelectorAll(".has-error");
        errors.forEach((error, index) => {
          const input = error.querySelector("input, textarea, select");
          const message = error.querySelector(".messages");
          const id = input.getAttribute("id") + "-message";
          input.setAttribute("aria-describedby", id);
          message.setAttribute("id", id);
          if (index === 0) {
            input.focus();
          }
        });
      }, 500);
    });
  }
};
